import React, {forwardRef} from 'react'
import {connect} from "dva";
import {useUpdateEffect} from "ahooks";

import {Spin, Typography} from "antd5";

import {modelUtils} from "@/utils";
import {ExportExcel} from "@/components";

const {Paragraph} = Typography

const Index = (
  {
    refInstance: ref,
    dispatch,
    trainPathLearningScoreSpecialLoading: loading = false,
    importRes,

    type,
    changeModal,
  }
) => {
  useUpdateEffect(() => {
    const {success, msg, data} = importRes || {}

    if (!success) {
      wizNotice.error(msg);
      return;
    }
    wizNotice.success({
      key: 'default',
      message: '成功',
      description: <div dangerouslySetInnerHTML={{__html: typeof data === 'string' ? data?.replaceAll?.('\r\n', '<br/>') || msg : msg}}/>,
      duration: 10,
    })
    changeModal && changeModal(false, true)
  }, [importRes])


  const infoProps = {
    title: '导入说明',
    text: [
      <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
      <Paragraph>2、按照要求格式填写信息</Paragraph>,
      <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
    ]
  }


  const operateProps = {
    title: '导入',
    template: {
      label: '模版下载',
      fileName: '模版.xlsx',
      href: '',
    }
  }

  const submit = (file, fileData, other) => {
    console.log('submit:', file, fileData, other)
    console.table(fileData)
    const data = fileData?.map(item => {
      const {
        账号: userName,
        岗位: positionName,
        路径: pathName,
        星级: lv,
        赠送积分: score,
      } = item || {}

      return {
        userName,
        positionName,
        pathName,
        lv,
        score,
      }
    })
    console.table(data)

    dispatch({
      type: `trainPathLearningScoreSpecial/import`,
      payload: {
        key: 'trainPathLearningScoreSpecial@import',
        apiParams: {
          list: data,
        }
      }
    })
  }


  return (
    <div>
      <Spin tip={'文件上传中'} spinning={loading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          // other={other}
          submit={submit}
        />
      </Spin>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const {trainPathLearningScoreSpecial} = state

  const importRes = modelUtils.getModelEntity(trainPathLearningScoreSpecial, 'trainPathLearningScoreSpecial@import');
  const load = modelUtils.getLoadingState(state, ['trainPathLearningScoreSpecial']);

  return {
    importRes,
    ...load,
  }
};

const Tc = connect(mapStateToProps, null, null, {forwardRef: true})(Index)
export default forwardRef((props, ref) => <Tc {...props} refInstance={ref}/>)

